module.exports = __webpack_public_path__ + "static/headerIcon-3b18c011f37e46dbe0e14bd7da8d6f45.png";